export const IMAGE_API: string = 'http://35.198.184.132:8080/winefinder/resources/';
export const API: string = 'http://35.198.184.132:8080/winefinder/resources/mobile/';
